import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiArrowRight } = FiIcons;

export default function ServiceCard({ title, image, link }) {
  return (
    <Link to={link} className="group block h-full">
      <div className="bg-white rounded-xl overflow-hidden shadow-soft hover:shadow-xl transition-all duration-300 h-full flex flex-col">
        <div className="h-56 overflow-hidden">
          <img 
            src={image} 
            alt={title} 
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        </div>
        <div className="p-8 flex-grow flex flex-col justify-between">
          <h3 className="text-xl font-bold text-secondary mb-4 group-hover:text-primary transition-colors">
            {title}
          </h3>
          <div className="flex items-center text-primary font-medium mt-4">
            <span>Learn More</span>
            <SafeIcon icon={FiArrowRight} className="ml-2 group-hover:translate-x-1 transition-transform" />
          </div>
        </div>
      </div>
    </Link>
  );
}